module.exports = __webpack_public_path__ + "img/benefits01-01.84de853.webp";